import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ProtectedRoute from "./component/protectedRoute";
import DashboardPage from "./page/dashboard";
import HomePage from "./page/home";
import RentalListPage from "./page/rentalList";
import DeletedRentalListPage from "./page/deletedRentalList";
import RentalEditPage from "./page/rentalEdit";
import ProductListPage from "./page/productList";
import ProductEditPage from "./page/productEdit";
import CustomerListPage from "./page/customerList";
import CustomerEditPage from "./page/customerEdit";
import ProfilePage from "./page/profile";
import LoginPage from "./page/login";
import ReportPage from "./page/report";

const App = () => {
	return (
		<Router>
			<Switch>
				<ProtectedRoute exact path="/" component={HomePage} />
				<ProtectedRoute exact path="/dash" component={DashboardPage} />
				<ProtectedRoute exact path="/rental" component={RentalListPage} />
				<ProtectedRoute exact path="/rental/deleted" component={DeletedRentalListPage} />
				<ProtectedRoute exact path="/rental/new" component={RentalEditPage} />
				<ProtectedRoute
					exact
					path="/rental/:rentalId"
					component={RentalEditPage}
				/>
				<ProtectedRoute exact path="/product" component={ProductListPage} />
				<ProtectedRoute exact path="/product/new" component={ProductEditPage} />
				<ProtectedRoute
					exact
					path="/product/:productId"
					component={ProductEditPage}
				/>
				<ProtectedRoute exact path="/customer" component={CustomerListPage} />
				<ProtectedRoute
					exact
					path="/customer/new"
					component={CustomerEditPage}
				/>
				<ProtectedRoute
					exact
					path="/customer/:customerId"
					component={CustomerEditPage}
				/>
				<ProtectedRoute exact path="/profile" component={ProfilePage} />
				<ProtectedRoute exact path="/report" component={ReportPage} />

				<Route exact path="/login" component={LoginPage} />
			</Switch>
		</Router>
	);
};

export default App;
